export const PRODUCT_TYPE_PERIOD = "period";
export const PRODUCT_TYPE_DATE = "date";
export const PRODUCT_TYPE_TIMESLOT = "timeslot";

export default {
  PRODUCT_TYPE_PERIOD,
  PRODUCT_TYPE_DATE,
  PRODUCT_TYPE_TIMESLOT,
};
